import { render, staticRenderFns } from "./cloumn-desc-modal.vue?vue&type=template&id=6e42fd9a"
import script from "./cloumn-desc-modal.vue?vue&type=script&lang=js"
export * from "./cloumn-desc-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e42fd9a')) {
      api.createRecord('6e42fd9a', component.options)
    } else {
      api.reload('6e42fd9a', component.options)
    }
    module.hot.accept("./cloumn-desc-modal.vue?vue&type=template&id=6e42fd9a", function () {
      api.rerender('6e42fd9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/log-management/cloumn-desc-modal.vue"
export default component.exports